import React, { Fragment, useContext, useEffect, useState } from "react";
import ReportDetail from "./ReportDetail";
import { UserActivityContext } from "./ContextProvider";
import DataTable from "react-data-table-component";
import { paginationComponentOptions } from "../../Shared/Constants/DatatableConstants";
import { activityUserColums } from "./Data/ReportActityuseData";
import TableButtons from "../../Shared/Components/TableButtons";

const TableData = () => {
  const {
    tableData,
    setRowsPerPage,
    setCurrentPage,
    currentPage,
    loading,
    rowsPerPage,
    totalRows,
    modalTogle,
    setItem,
    fetchTableData,
    filters,
  } = useContext(UserActivityContext);

  const [colums, setColums] = useState([]);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1); // Reset to first page
    fetchTableData(1, newPerPage);
  };

  const handleView = async (row) => {
    let reportRow = await tableData.find((e) => e.id === row.id);

    setItem(reportRow);
    modalTogle();
  };
  useEffect(() => {
    setColums([
      ...activityUserColums,
      {
        name: "Acciones",
        width: "250px",
        cell: (row) => (
          <TableButtons
            row={row}
            showViewButton={true}
            showDeleteButton={false}
            showEditButton={false}
            handleView={
              row?.event != "retrieved" && row?.event != "exported"
                ? handleView
                : false
            }
          ></TableButtons>
        ),
        ignoreRowClick: true, // Prevent action buttons from triggering row selection
        allowOverflow: true, // Prevent layout overflow issues
        button: true, // Indicate that it's a button column
      },
    ]);
  }, [tableData]);

  useEffect(() => {
    fetchTableData(currentPage, rowsPerPage);
  }, [currentPage, filters]);
  return (
    <Fragment>
      <DataTable
        data={tableData}
        columns={colums}
        striped={true}
        center={true}
        pagination
        paginationServer // Enables server-side pagination
        paginationTotalRows={totalRows} // Pass total rows to DataTable
        paginationComponentOptions={paginationComponentOptions}
        paginationDefaultPage={currentPage} // Default current page
        paginationPerPage={rowsPerPage} // Rows per page
        onChangePage={handlePageChange} // Handle page change
        onChangeRowsPerPage={handleRowsPerPageChange} // Handle rows per page change
        progressPending={loading} // Show loading spinner
      />
      <ReportDetail />
    </Fragment>
  );
};
export default TableData;
